import { useEffect, useRef, useState } from 'react';
import { Button, InputNumber, Space, Popover, Input, Modal, Flex } from 'antd';
import Icon, { CalculatorOutlined } from '@ant-design/icons';
import { evaluate } from "mathjs";
const InputNumber2 = (props) => {
    const [mathValue, setMathValue] = useState(0);
    const [thousandMode, setThousandMode] = useState(true);
    const [showCalculator, setShowCalculator] = useState(true);
    const mathInputRef = useRef()
    const calculate = () => {
        // var a = mathInputRef.current.value;
        // console.log(mathInputRef.current.input.value)
        // alert(a);

        if (props.onChange) {
            props.onChange(mathValue);
        }
    }


    const onMathExpressChange = (e) => {
        try {
            var str = e.target.value;
            str = str.replaceAll(":", "/");
            str = str.replaceAll("x", "*")
            str = str.trim();
            if (str === "") {
                setMathValue(0);
                return;
            }
            var a = evaluate(str);
            if (thousandMode) {
                setMathValue(parseInt(a * 1000));
            } else {
                setMathValue(a);
            }

        } catch (error) {
            setMathValue(0);
        }
        // console.log(e.target.value);
    }


    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
        calculate();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    useEffect(() => {

        if (props.showCalculator === false) {
            setShowCalculator(false);
        } else {
            setShowCalculator(true);
        }

    }, [props.showCalculator])

    const roundUp = () => {
        var a = mathValue / 1000;
        a = a + 1;
        a = parseInt(a)
        setMathValue(a * 1000)
    }

    const roundDown = () => {
        var a = mathValue / 1000;
        a = a - 1;
        a = parseInt(a)
        setMathValue(a * 1000)
    }


    return (

        <>

            <div style={{ display: "flex", gap: 8 }}>
                <div>
                    <InputNumber
                        {...props}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                        style={props.style ? props.style : { minWidth: 100 }}

                    />
                </div>

                {showCalculator &&
                    <Button onClick={showModal} ><CalculatorOutlined /></Button>

                }



                {/* 
                <Popover content={<>
                    <Space>
                        <Input placeholder='Nhập phép tính' ref={mathInputRef} onChange={e => { onMathExpressChange(e) }} suffix={"000"}></Input>
                        <div style={{ width: 75, textAlign: "left" }}>{mathValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                        <Button type='primary' onClick={e => { calculate() }}> OK</Button>
                    </Space>

                </>} title="Tính" trigger="click">
                    <Button >Tính</Button>
                </Popover> */}



            </div>
            <Modal title="Máy tính" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Space direction='vertical' style={{ width: "100%" }} >
                    <Input style={{ minWidth: 150 }} placeholder='Nhập phép tính' ref={mathInputRef} onChange={e => { onMathExpressChange(e) }} suffix={<Button onClick={e => setThousandMode(!thousandMode)} type={thousandMode ? "primary" : "link"} >0.000</Button>}></Input>
                    <Flex>
                        <Space>
                            <Button onClick={roundUp}>Up</Button>
                            <Button onClick={roundDown}>Down</Button>
                        </Space>
                        <div style={{ width: "100%", textAlign: "right", fontWeight: 500 }}>{mathValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                    </Flex>


                </Space>
            </Modal>

        </>
    )



}
export default InputNumber2;